import type { IntlCheck } from './types';

async function loadPolyfills(checks: readonly IntlCheck[], locale: string) {
	await Promise.all(
		checks.map(async ({ polyfill, fixNativeIntlFeature }) => {
			const res = await polyfill(locale);
			fixNativeIntlFeature && fixNativeIntlFeature(res);
		}),
	);
}

function checkSingle(check: IntlCheck, locale: string): boolean {
	return (
		check.dependencies.every((innerCheck) => checkSingle(innerCheck, locale)) && check.checkNativeIntlFeature(locale)
	);
}

export function checkAllFeatures(checks: readonly IntlCheck[], locale: string): Readonly<Record<string, boolean>> {
	return checks.reduce<Record<string, boolean>>((acc, cur) => {
		// eslint-disable-next-line no-param-reassign
		acc[cur.name] = checkSingle(cur, locale);
		return acc;
	}, {});
}

export async function loadMissingFeatures(checks: readonly IntlCheck[], locale: string): Promise<void> {
	const missingFeatures = checks.filter((check) => !checkSingle(check, locale));

	if (missingFeatures.length) {
		await loadPolyfills(missingFeatures, locale);
	}
}
